import axios from 'axios';

export const GET_PAYMENTS_URL = '/bituahLeumiPayments/getPayments';
export const UPLOAD_EXCEL_FILE = '/bituahLeumiPayments/uploadExcelFile';
export const UPDATE_MANUAL_STATUS = '/bituahLeumiPayments/updateManualStatus';
export const RESEND_PAYMENT = '/bituahLeumiPayments/resendPayment';
export const DOWNLOAD_PAYMENT_CONFIRM = '/bituahLeumiPayments/getPaymentConfirmFile';
export const GET_PAYMENTS_FILE = '/bituahLeumiPayments/getPaymentsDataForExcelFile';
export const ADD_BIRTH_DATE = '/bituahLeumiPayments/addBirthDateToAgent';
export const UPDATE_AMOUNT = '/bituahLeumiPayments/updateDebtAndInsuranceAmount';

export function findPayments(queryParams, cancellationHandlers) {
  return axios.get(GET_PAYMENTS_URL, {params: queryParams, ...cancellationHandlers});
}

export function uploadFile({formData}) {
  return axios.post(UPLOAD_EXCEL_FILE, formData);
}

export function updateManualStatus(paymentRequestID) {
  return axios.post(UPDATE_MANUAL_STATUS, paymentRequestID);
}

export function resendPayment(paymentRequestID) {
  return axios.post(RESEND_PAYMENT, paymentRequestID);
}

export function downloadPaymentConfirm(paymentRequestID) {
  return axios.post(DOWNLOAD_PAYMENT_CONFIRM, paymentRequestID);
}

export function getPaymentsFile(queryParams) {
  return axios.get(GET_PAYMENTS_FILE, {params: queryParams});
}

export function addBirthDateToAgent({agentID, birthDate}) {
  return axios.post(ADD_BIRTH_DATE, {agentID, birthDate});
}

export function updateAmount({paymentRequestID, debtAmount, insuranceAmount}) {
  return axios.post(UPDATE_AMOUNT, {paymentRequestID, debtAmount, insuranceAmount});
}
